import React, { ReactNode } from 'react';

// Components
import Typography from '@components/UI-KIT/Typography';
import Divider from '../UI-KIT/Divider';
import { daysOfTheWeek, months } from '@components/UI-KIT/Inputs/DateInput';

// Material ui
import { Grid } from '@material-ui/core';

// Styles
import './Receipt.scss';

interface Props {
    title: string;
    heroTitle: string;
    heroSubtitle?: string;
    sections: ReactNode[];
}

const Receipt: React.FC<Props> = ({
    title,
    heroTitle,
    heroSubtitle,
    sections
}) => {
    const currentDate = `${daysOfTheWeek[new Date().getDay()]}, ${new Date().getDate()} de ${months()[new Date().getMonth()]} de ${new Date().getFullYear()}`;

    return (
        <Grid
            className="ui-Receipt"
        >
            <Grid
                className="ui-Receipt-header"
            >
                <img
                    src="/Completo.svg"
                    alt="Alquileres Online"
                />
                <Typography
                    variant="table-regular"
                    align="right"
                >
                    <strong>{title}</strong>
                    <br />
                    {currentDate}
                </Typography>
            </Grid>
            <table>
                <thead><tr><td>
                    <div
                        className="ui-Receipt-header-space"
                    >
                        &nbsp;
                    </div>
                </td></tr></thead>
                <tbody>
                    <tr
                        className="ui-Receipt-section"
                    >
                        <td>
                            <Grid
                                className="ui-Receipt-hero"
                            >
                                <Typography
                                    className="ui-Receipt-hero-title"
                                    variant="h1"
                                    color="primary-dark"
                                >
                                    {heroTitle}
                                </Typography>
                                { heroSubtitle && (
                                    <Typography
                                        className="ui-Receipt-hero-subtitle"
                                        variant="h2"
                                    >
                                        {heroSubtitle}
                                    </Typography>
                                )}
                            </Grid>
                            <Divider/>
                        </td>
                    </tr>
                    {sections.map((s, i) => (
                        <tr
                            key={`ui-Receipt-section-${i + 1}`}
                            className="ui-Receipt-section"
                        >
                            <td>
                                {s}
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot><tr><td>
                    <div
                        className="ui-Receipt-footer-space"
                    >
                        &nbsp;
                    </div>
                </td></tr></tfoot>
            </table>
            <Grid
                className="ui-Receipt-footer"
            >
                <Grid>
                    <Grid
                        container
                        wrap="nowrap"
                    >
                        <Typography
                            variant="table-semibold"
                        >
                            Alquileres Online.&nbsp;
                        </Typography>
                        <Typography
                            variant="table-regular"
                        >
                            Obispo Trejo 961, 1A. Córdoba, Argentina
                        </Typography>
                    </Grid>
                    <Typography
                        variant="table-regular"
                        color="secondary"
                    >
                        www.alquileresonline.pro
                    </Typography>
                </Grid>
                <Grid
                    className="ui-Receipt-footer-zenrise"
                >
                    <Grid>
                        <Typography
                            variant="table-regular"
                        >
                            Creado por el equipo de Zenrise
                        </Typography>
                        <Typography
                            variant="table-regular"
                            color="primary-dark"
                        >
                            www.zenrise.io
                        </Typography>
                    </Grid>
                    <img
                        src="/images/Zenrise-logo.png"
                        alt="Zenrise"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Receipt;
